import { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Container, Row, Col, Image, Button } from "react-bootstrap";

import SearchBox from "../../components/common/searchBox/searchBox";
import CustomCard from "../../components/common/customCard";
import CategoryCard from "../../components/common/categoryCard";
import FilterDropdown from "../../components/common/filterDropdown/filterDropdown";
// import MarqueeWrapper from "../../components/common/marqueeSlider";
import SimpleLoader from "../../components/common/simpleLoader/Loader";
import HeroImage from "../../assests/images/banner-section/hero-section-image.webp";
import { MESSAGE } from "../../utils/message";
import LatestNews from "./latestNews/latestNews";
import BlogCard from "../../components/common/blogCard";
import Help_people_icon from "../../assests/images/search-page-images/message-heart.svg";
import Help_people_list_icon from "../../assests/images/help_people_list_icon.svg";
import Help_People_banner_image from "../../assests/images/help-people-banner-image.webp";
import {
  BannerSection,
  BannerLeftSide,
  BannerRightImage,
  BannerTitle,
  BannerSubTitle,
  GetOurLatestNews,
  CategorySection,
  SectionTitle,
  SectionTitleText,
  SectionTitleDropdown,
  BlogSection,
  HelpPeopleNowSection,
  HelpPeopleColLeft,
  HelpPeopleColRight,
  HelpPeopleSubTitle,
  HelpPeopleTitle,
  HelpPeopleText,
  HelpPeopleList,
  HelpPeopleListItem,
  HelpPeopleBtn,
  HelpPeopleImage,
  HelpPeopleCount,
  PeopleHelpCount,
  PeopleHelpText,
  HelpPeopleColInner,
} from "./homeStyle";
import { useDispatch, useSelector } from "react-redux";
import { totalCountHandler } from "../../redux/slices/donationCamp/totalCount-slice";
import { useNavigate } from "react-router-dom";
import { blogListHandler } from "../../redux/slices/blogs/blogList-slice";
import { campCategoryHandler } from "../../redux/slices/donationCamp/campCategory-slice";
import { DropdownOptions, NonprofitProps } from "../../utils/types";
import { nonprofitsHandler } from "../../redux/slices/donationCamp/nonprofit-slice";
import { similarNonprofitsHandler } from "../../redux/slices/donationCamp/similarNonprofits-slice";
import MetaComponent from "../../components/common/metaComponent";

const options: DropdownOptions[] = [
  { label: "Most Relevant", value: "most-relevant" },
  { label: "Highest Rating", value: "highest-rating" },
  { label: "Name", value: "name" },
];

const Home = () => {
  const dispatch: any = useDispatch();
  const navigate = useNavigate();
  const [selectedFilter, setSelectedFilter] = useState<string | number>(
    options[0].value
  );

  const [categorySlug, setCategorySlug] = useState<number | string>("all");
  const [categoryName, setCategoryName] = useState<string>("all");
  const [selectedCitySlug, setSelectedCitySlug] = useState("san-francisco");
  const [selectedCity, setSelectedCity] = useState("");
  const [allNonprofitList, setAllNonprofitList] = useState<NonprofitProps[]>(
    []
  );

  const [loader, setLoader] = useState(false);
  const [categoryWiseDataNotFound, setCategoryWiseDataNotFound] =
    useState(false);
  const [pageNo, setPageNumber] = useState<number>(1)
  const availableModules = useSelector((state: any) => state?.modules?.data?.results);
  const campCategory: any = useSelector(
    (state: any) => state?.campCategory?.data?.results
  );
  const totalCampCount: any = useSelector(
    (state: any) => state?.totalCampCount
  );
  const blogList = useSelector((state: any) => state?.blogList?.data?.results);
  const nonprofitsData: NonprofitProps[] = useSelector(
    (state: any) => state?.nonprofits?.data?.results
  );
  const nonprofitsDataCount: number = useSelector(
    (state: any) => state?.nonprofits?.data?.count
  );
  const similarNonprofitsData: NonprofitProps[] = useSelector(
    (state: any) => state?.similarNonprofits?.data?.results
  );
  // const [lastFilters, setLastFilters] = useState<{
  //   selectedCitySlug: string;
  //   categorySlug: string | number;
  //   selectedFilter: string | number;
  // }>({
  //   selectedCitySlug: "",
  //   categorySlug: "all",
  //   selectedFilter: options[0].value,
  // });
  useEffect(() => {
    dispatch(totalCountHandler());
    dispatch(blogListHandler("", "", "", ""));
    dispatch(campCategoryHandler());
  }, []);

  useEffect(() => {
    setLoader(false);
  }, [nonprofitsData]);

  useEffect(() => {
    setLoader(true);
    //setAllNonprofitList([])
    dispatch(
      nonprofitsHandler({
        all: false,
        search: '',
        country: '',
        state: '',
        city: selectedCitySlug,
        zipcode: "",
        category: categorySlug === "all" ? "" : categorySlug,
        sort_by: selectedFilter as string,
        page: pageNo,
        size: 9,
      })
    ).then(() => {
      setLoader(false);
    }).catch(() => {
      setLoader(false);

    });
    setCategoryWiseDataNotFound(false);
  }, [dispatch, selectedCitySlug, selectedFilter, categorySlug, pageNo]);

  // useEffect(() => {

  //   dispatch(
  //     nonprofitsHandler({
  //       all: false,
  //       search: '',
  //       country: '',
  //       state: '',
  //       city: selectedCitySlug,
  //       zipcode: '',
  //       category: categorySlug === "all" ? "" : categorySlug as string,
  //       sort_by: selectedFilter as string,
  //       page: pageNo,
  //       size: 9,
  //     })
  //   ).then(() => {
  //     setLoader(false);
  //   }).catch(() => {
  //     setLoader(false);
  //   });
  // }, [pageNo]);

  // useEffect(() => {
  //   setLoader(true);
  //   setAllNonprofitList([])
  //   dispatch(
  //     nonprofitsHandler(
  //       {
  //         all: false,
  //         search: '',
  //         country: '',
  //         state: '',
  //         city: selectedCitySlug,
  //         zipcode: "",
  //         category: categorySlug === "all" ? "" : categorySlug as string,
  //         sort_by: selectedFilter as string,
  //         page: 1,
  //         size: 9
  //       }

  //     )

  //   ).then(() => {
  //     setLoader(false);
  //   }).catch(() => {
  //     setLoader(false);
  //   });
  //   // setNonProfitLoader(true);
  //   setCategoryWiseDataNotFound(false);
  // }, [selectedCitySlug, selectedFilter, categorySlug]);

  useEffect(() => {
    if (
      ((categorySlug && categorySlug !== "all") || selectedCity) &&
      allNonprofitList &&
      allNonprofitList?.length === 0 &&
      nonprofitsData?.length === 0
    ) {
      setCategoryWiseDataNotFound(true);
      dispatch(similarNonprofitsHandler());
    }
    if (nonprofitsData?.length > 0) {
      setCategoryWiseDataNotFound(false);
    }
  }, [categorySlug, allNonprofitList, selectedCity, nonprofitsData]);
  // useEffect(() => {


  //   if (nonprofitsData && nonprofitsData.length > 0) {
  //     setAllNonprofitList(prev => [...prev, ...nonprofitsData]);
  //   }
  // }, [nonprofitsData, selectedCitySlug, categorySlug, selectedFilter]);
  useEffect(() => {
    if (nonprofitsData?.length > 0) {
      setAllNonprofitList((prev) => {
        return pageNo === 1 ? nonprofitsData : [...prev, ...nonprofitsData]; // Append only on pagination change
      });
    }
  }, [nonprofitsData]);

  // useEffect(() => {
  // setAllNonprofitList(nonprofitsData);
  // }, [nonprofitsData]);

  return (
    <>
      <MetaComponent
        keywords="nonprofits, non-profits, not for profits, volunteer, donate, donation, volunteering, ratings, rate, best non-profits, best nonprofits, best charities, top nonprofits, top charities, top non-profits, charitable giving, giving to nonprofits"
        description="Find and review charities, nonprofits and volunteering and donation opportunities. Want to donate or volunteer? Find the best local non-profit or charity."
        ogTitle="Find Top-Rated Nonprofits and Charities | Great Nonprofits"
        ogDescription="Find and review charities, nonprofits and volunteering and donation opportunities. Want to donate or volunteer? Find the best local non-profit or charity"
        ogUrl="https://new.greatnonprofits.org/"
        ogImage="https://cdn.greatnonprofits.org/img/gnp-facebook-share-lg.png"
        twitterTitle="Find Top-Rated Nonprofits and Charities | Great Nonprofits"
        twitterDescription="Find and review charities, nonprofits and volunteering and donation opportunities. Want to donate or volunteer? Find the best local non-profit or charity"
        twitterUrl="https://new.greatnonprofits.org/"
        twitterImage="https://cdn.greatnonprofits.org/img/gnp-facebook-share-lg.png"
      />
      <BannerSection>
        <Container className="cont-w">
          <Row className="col-center align-items-center get-started-banner">
            <BannerLeftSide as={Col} md="12" lg="8">
              <BannerTitle>{MESSAGE.bannerTitle}</BannerTitle>
              <BannerSubTitle>{MESSAGE.bannerSubTitle}</BannerSubTitle>
              <SearchBox />
            </BannerLeftSide>

            <BannerRightImage as={Col} md="12" lg="4">
              <Image src={HeroImage} alt="Hero image" />
            </BannerRightImage>
          </Row>
        </Container>
      </BannerSection>

      <GetOurLatestNews>
        <Container className="cont-w">
          <Row>
            <LatestNews
              setSelectedCity={setSelectedCity}
              selectedCity={selectedCity}
              setSelectedCitySlug={setSelectedCitySlug}
              categorySlug={categorySlug}
              selectedCitySlug={selectedCitySlug}
              selectedFilter={selectedFilter}
            />
          </Row>
        </Container>
      </GetOurLatestNews>
      {/* <Loader/> */}
      <CategorySection>
        <Container className="cont-w">
          <Row>
            <SectionTitle className="city-list-section-title">
              <SectionTitleText>
                {MESSAGE.nonprofitsText(selectedCity)}
              </SectionTitleText>
              <SectionTitleDropdown>
                <FilterDropdown
                  options={options}
                  selectedFilter={selectedFilter}
                  setSelectedFilter={setSelectedFilter}
                />
              </SectionTitleDropdown>
            </SectionTitle>

            <CategoryCard
              setCategorySlug={setCategorySlug}
              categorySlug={categorySlug}
              setCategoryName={setCategoryName}
              categoryData={campCategory}
            />

          </Row>
          <Row>
            {loader ? (
              <div style={{ position: 'relative' }}>
                <SimpleLoader />
              </div>
            ) : (
              <CustomCard
                count={nonprofitsDataCount}
                cardData={
                  allNonprofitList?.length > 0
                    ? allNonprofitList
                    : similarNonprofitsData
                }
                selectedCity={selectedCity}
                selectedCategory={categoryName}
                categoryWiseDataNotFound={categoryWiseDataNotFound}
                setPageNumber={setPageNumber}
                nonProfitLoader={loader}
              />
            )}
          </Row>
        </Container>
      </CategorySection>

      <HelpPeopleNowSection>
        <Container fluid>
          <Row>
            <HelpPeopleColLeft as={Col} sm={12} md={12} lg={5}>
              <HelpPeopleColInner>
                <HelpPeopleSubTitle>
                  <Image
                    src={Help_people_icon}
                    alt="HelpPeople icon"
                    width="30"
                    height="30"
                  />
                  {MESSAGE.helpPeopleSubtitle}
                </HelpPeopleSubTitle>
                <HelpPeopleTitle>{MESSAGE.helpPeopleTitle}</HelpPeopleTitle>
                <HelpPeopleText>{MESSAGE.helpPeopleText}</HelpPeopleText>
                <HelpPeopleList>
                  <HelpPeopleListItem>
                    <Image
                      src={Help_people_list_icon}
                      alt="list icon"
                      width="20"
                      height="20"
                    />
                    {MESSAGE.helpPeopleListItem}
                  </HelpPeopleListItem>
                  <HelpPeopleListItem>
                    <Image
                      src={Help_people_list_icon}
                      alt="list icon"
                      width="20"
                      height="20"
                    />
                    {MESSAGE.helpPeopleListItem2}
                  </HelpPeopleListItem>
                  <HelpPeopleListItem>
                    <Image
                      src={Help_people_list_icon}
                      alt="list icon"
                      width="20"
                      height="20"
                    />
                    {MESSAGE.helpPeopleListItem3}
                  </HelpPeopleListItem>
                </HelpPeopleList>
                {availableModules?.donation && <HelpPeopleBtn>
                  <Button
                    className="donate-now-btn"
                    onClick={() => { typeof localStorage !== "undefined" && localStorage.removeItem("search"); navigate("/org/greatnonprofits") }}
                  >
                    {MESSAGE.donateNowBtn}
                  </Button>
                </HelpPeopleBtn>}
              </HelpPeopleColInner>
            </HelpPeopleColLeft>

            <HelpPeopleColRight as={Col} sm={12} md={12} lg={7}>
              <HelpPeopleImage>
                <Image
                  src={Help_People_banner_image}
                  alt="help-people-banner"
                  width="810"
                  height="566"
                />
                <HelpPeopleCount>
                  <PeopleHelpCount className="people-help-count">
                    {totalCampCount?.data?.compaign_count}
                  </PeopleHelpCount>
                  <PeopleHelpText className="people-help-text">
                    {MESSAGE.peopleHelpText}
                  </PeopleHelpText>
                </HelpPeopleCount>
              </HelpPeopleImage>
            </HelpPeopleColRight>
          </Row>
        </Container>
      </HelpPeopleNowSection>
      <BlogSection>
        <Container className="cont-w">
          <Row>
            <BlogCard blogData={blogList?.slice(0, 3)} />
          </Row>
        </Container>
      </BlogSection>
      {/* <MarqueeWrapper /> */}
    </>
  );
};
export default Home;
